<template>
  <div class="customer-queue">
    <div class="customer-queue-header">
      {{ TUITranslateService.t("AIDesk.排队等待中") }}...
    </div>
    <div class="customer-queue-info">
      {{ TUITranslateService.t("AIDesk.排队等待话术") }}
    </div>
    <div class="customer-queue-container">
      <div class="customer-queue-content-title">
        {{ TUITranslateService.t("AIDesk.当前前方排队人数") }}
      </div>
      <div class="customer-queue-content-number">
        {{ props.queueNumber }}
      </div>
    </div>
    <div class="customer-queue-end-button">
      <div :class="['customer-queue-end-button-content', isClicked ? 'button-clicked' : '']" @click="leaveQueue">
        {{ TUITranslateService.t("AIDesk.结束排队") }}
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import vue from '../../../adapter-vue';
const { ref, onMounted, onUnmounted } = vue;
import { IConversationModel, StoreName, TUIStore, TUITranslateService } from '../../../@aidesk/uikit-engine';
import { getTo, leaveQueuing } from '../../../utils/utils';
const currentConversation = ref<IConversationModel>();
const isClicked = ref(false);
const props = defineProps({
  queueNumber: {
    type: Number,
    default: 0
  },
});
const emits = defineEmits(['closeQueuePage']);
onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
});

const onCurrentConversationUpdate = (conversation: IConversationModel) => {
  currentConversation.value = conversation;
};

const leaveQueue = () => {
  if (isClicked.value) {
    return;
  }
  isClicked.value = true;
  leaveQueuing(getTo(currentConversation.value));
  emits('closeQueuePage');
}
</script>
<style lang="scss">
.customer-queue {
  width: 100%;
  height: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.customer-queue-header {
  height: 52px;
  background-color: #1C66E5;
  color: white;
  line-height: 52px;
  padding-left: 20px;
}
.customer-queue-info {
  padding: 20px;
  color: #666;
}
.customer-queue-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;    
  justify-content: center;
  color: #1C66E5;
}

.customer-queue-content-title {
  font-size: 20px;
  margin-bottom: 10px;
}

.customer-queue-content-number {
  font-size: 40px;
  font-weight: bold;
}
.customer-queue-end-button {
  color: white;
  padding: 8px 23px;
  border-radius: 10px;
}
.customer-queue-end-button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  &-content {
    background: #1c66e5;
    color: white;
    padding: 8px 23px;
    border-radius: 10px;
    width: fit-content;
    min-width: 70px;
    cursor: pointer;
    display: flex;
    justify-content: center;
  }
}
.button-clicked {
  cursor: default;
  background: #cccccc;
  color: #666666;
}
</style>